module.exports = __webpack_public_path__ + "img/235.5a9f405f.png";